import { classByKey, DocumentClassKey } from '@ps-gui/shared-core';

export const documentClassesWithDedicatedForms = new Set<DocumentClassKey>([
  '25_Q3_FORDERUNGSAUFSTELLUNG',
  '25_Q3_301ER_DATEN',
  '25_Q3_AUFTRAGSFORMULAR_ESE',
  '25_Q3_AUFTRAGSFORMULAR_ATTEST',
  '25_Q3_EUCON_FRAGEBOGEN',
]);

const defaultProofDocumentClasses = new Set<DocumentClassKey>([
  '25_Q3_FORDERUNGSAUFSTELLUNG',
  '25_Q3_301ER_DATEN',
]);

// Gutachten should display a form for all document classes (exception archived), so every
// Dokument can get a creation date assigned.
const defaultGutachtenDocumentClasses = new Set<DocumentClassKey>(
  Object.keys(classByKey)
    .map((c) => c as DocumentClassKey)
    .filter((c) => c !== '25_Q3_SONSTIGES'),
);

export const allowedDocumentClassesPerAuftragsart: Record<string, Set<DocumentClassKey>> = {
  REGRESSPRUEFUNG: defaultProofDocumentClasses,
  ABFINDUNGSANGEBOT: defaultProofDocumentClasses,
  MEDIZINISCHE_EXPERTISE: defaultProofDocumentClasses,
  PFLEGERISCHE_EXPERTISE: defaultProofDocumentClasses,
  RESERVE: defaultProofDocumentClasses,
  GUTACHTEN_AKTENLAGE: defaultGutachtenDocumentClasses,
  GUTACHTEN_VORSTELLUNG: defaultGutachtenDocumentClasses,
  GUTACHTEN_STELLUNGNAHME: defaultGutachtenDocumentClasses,
  ESE: new Set(['25_Q3_AUFTRAGSFORMULAR_ESE']),
  ATTEST: new Set(['25_Q3_AUFTRAGSFORMULAR_ATTEST', '25_Q3_EUCON_FRAGEBOGEN']),
  ANDERE_ANFRAGE: defaultProofDocumentClasses,
};
